import Promise from 'bluebird';
import actions from './actions';
import AnchorAPI from '../../../modules/AnchorAPI';

const { setPodcast } = actions;

function getPodcastEpisodeIds(episodes) {
  if (episodes && episodes.length > 0) {
    return episodes.map(episode => episode.podcastEpisodeId);
  }
  return [];
}

// TODO: Joe, this is shitty code. You're grounded...
// TODO: ADD PROPER ERROR HANDLING!
const fetchPodcast = () =>
  new Promise((resolve, reject) => {
    let podcast = {};
    AnchorAPI.fetchPodcastEpisodes()
      .then(podcastEpisodesJSON => {
        podcast = {
          ...podcastEpisodesJSON,
          podcastEpisodes: [],
          episodesById: {},
          podcastEpisodeIds: getPodcastEpisodeIds(
            podcastEpisodesJSON.podcastEpisodes
          ),
        };
        /*
        Promise.all(
          podcastEpisodes.map(episode =>
            AnchorAPI.fetchPodcastEpisode(episode.podcastEpisodeId).then(
              responseJSON => {
                const { episodeAudios, ...restResponseJSON } = responseJSON;
                podcast.episodesById[episode.podcastEpisodeId] = {
                  // TODO: We need to put episode metadata in each episode
                  // metadata: {},
                  audiosById: episodeAudios.reduce(
                    (audioByIdTemp, episodeAudio) => ({
                      ...audioByIdTemp,
                      [episodeAudio.audioId]: episodeAudio,
                    }),
                    {}
                  ),
                  ...episode,
                  ...restResponseJSON,
                  episodeAudioIds: episodeAudios.map(audio => audio.audioId),
                };
              }
            )
          )
        )
        */
        Promise.resolve().then(() => {
          AnchorAPI.fetchMoney().then(responseJSON => {
            podcast.money = responseJSON;
            AnchorAPI.fetchPodcastStatus()
              .then(podcastStatusJSON => {
                podcast.status = podcastStatusJSON;
                AnchorAPI.fetchMyPodcastMetadata()
                  .then(podcastMetadataJSON => {
                    const { webStationId } = podcastMetadataJSON;
                    podcast = {
                      ...podcast,
                      metadata: podcastMetadataJSON,
                      webStationId,
                      stationId: webStationId,
                    };
                    // TODO: migrate to webStationId
                    AnchorAPI.fetchPodcastProfileForStation(webStationId)
                      .then(profileJSON => {
                        podcast.profile = profileJSON;
                        AnchorAPI.fetchAdCompaignsForStation(webStationId)
                          .then(responseJSON => {
                            const { adCampaigns, audios } = responseJSON;
                            const campaigns = adCampaigns.map(
                              adCampaignJSON => {
                                const {
                                  audioId: campaignAudioId,
                                  exampleAudioId: campaignExampleAudioId,
                                } = adCampaignJSON;
                                return {
                                  ...adCampaignJSON,
                                  audio: audios.find(audioJSON => {
                                    const { audioId } = audioJSON;
                                    return audioId === campaignAudioId;
                                  }),
                                  exampleAudio: audios.find(audioJSON => {
                                    const { audioId } = audioJSON;
                                    return audioId === campaignExampleAudioId;
                                  }),
                                };
                              }
                            );
                            podcast.campaigns = campaigns;
                            resolve(podcast);
                          })
                          .catch(error => {
                            console.error(
                              `fetchAdCompaignsForStation error: ${error}`
                            );
                          });
                      })
                      .catch(error => {
                        console.error(
                          `fetchPodcastProfileForStation error: ${error}`
                        );
                      });
                  })
                  .catch(error => {
                    console.error(`fetchMyPodcastMetadata error: ${error}`);
                  });
              })
              .catch(error => {
                console.error(`fetchPodcastStatus error: ${error}`);
              });
          });
        });
      })
      .catch(error => {
        console.error(`fetchPodcastEpisodes error: ${error}`);
      });
  });

// TODO: Add fetch states: start, succeeded, failed
const fetchPodcastAndSet = () => dispatch =>
  fetchPodcast().then(podcast => {
    dispatch(setPodcast(podcast));
  });

const getIsOptedOutOfDistributionFromPodcastStatus = podcastStatus => {
  const isOptedOutFromDatabase = podcastStatus === 'optedout';
  return isOptedOutFromDatabase;
};

export default {
  fetchPodcastAndSet,
  getIsOptedOutOfDistributionFromPodcastStatus,
};
